module.exports = __webpack_public_path__ + "static/img/wh-105.b968cd05.png";